<template>
    <div class="modal-overlay">
        <div class="modal-content proc-modal-large">

            <div class="modal-header">
                <h2>{{ props.tituloForm }}</h2>
                <h3>Selecione as Assinaturas Necessárias</h3>
            </div>

            <div
                v-if="msgAlerta"
                class="alert-error modal-alert"
            >
                {{ msgAlerta }}
            </div>

            <div class="modal-body">
                <div
                    v-if="isLoading"
                    class="loading-local"
                >
                    Carregando...
                </div>

                <template v-else>

                    <!-- ASSINATURAS SUGERIDAS -->
                    <section v-if="lsSugeridas.length">
                        <div class="assinatura-section-header">
                            <div>
                                <div class="assinatura-section-title">
                                    Assinaturas sugeridas
                                </div>

                                <div class="assinatura-section-subtitle">
                                    Usuários diretamente relacionados ao documento.
                                </div>
                            </div>

                            <span class="assinatura-contador">
                                {{ lsSugeridas.length }}
                            </span>
                        </div>

                        <div class="assinaturas-lista">
                            <div
                                v-for="item in lsSugeridas"
                                :key="`sugerido-${item.idusuario}`"
                                class="assinatura-card"
                                :class="{ ativo: item.ckvincular === 'S' }"
                                @click="toggleAssinatura(item)"
                            >
                                <div class="assinatura-info">
                                    <div class="assinatura-nome">
                                        {{ item.nmusuario }}
                                    </div>

                                    <div class="assinatura-perfil">
                                        {{ item.nmperfil }}
                                    </div>

                                    <div class="assinatura-fone">
                                        ☎ {{ item.celular || 'Telefone não informado' }}
                                    </div>
                                </div>

                                <div
                                    class="assinatura-toggle-area"
                                    @click.stop
                                >
                                    <span class="assinatura-status">
                                        {{
                                            item.ckvincular === 'S'
                                                ? 'Assinar'
                                                : 'Não assinar'
                                        }}
                                    </span>

                                    <label class="switch">
                                        <input
                                            v-model="item.ckvincular"
                                            type="checkbox"
                                            true-value="S"
                                            false-value="N"
                                        />

                                        <span class="slider"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </section>

                    <!-- NENHUM SUGERIDO -->
                    <div
                        v-else
                        class="info-empty"
                    >
                        Nenhum usuário sugerido foi encontrado para este documento.
                    </div>

                    <!-- BOTÃO PARA CARREGAR/EXIBIR EXTRAS -->
                    <div
                        v-if="props.idSim > 0 && props.permitirOutros"
                        class="extras-action"
                    >
                        <button
                            type="button"
                            class="btn-extras"
                            :disabled="isLoadingExtras"
                            @click="alternarExtras"
                        >
                            <template v-if="isLoadingExtras">
                                Carregando outros usuários...
                            </template>

                            <template v-else-if="!extrasCarregados">
                                Exibir outros ADM e RT do S.I.M.
                            </template>

                            <template v-else-if="!exibirExtras">
                                Exibir outros ADM e RT

                                <span class="btn-extras-count">
                                    {{ lsExtras.length }}
                                </span>
                            </template>

                            <template v-else>
                                Ocultar outros ADM e RT
                            </template>
                        </button>
                    </div>

                    <!-- ASSINATURAS EXTRAS -->
                    <section
                        v-if="exibirExtras && extrasCarregados"
                        class="extras-section"
                    >
                        <div class="assinatura-section-header">
                            <div>
                                <div class="assinatura-section-title">
                                    Outros usuários disponíveis
                                </div>

                                <div class="assinatura-section-subtitle">
                                    ADM e RT vinculados a estabelecimentos deste S.I.M.
                                </div>
                            </div>

                            <span class="assinatura-contador secundario">
                                {{ lsExtras.length }}
                            </span>
                        </div>

                        <div
                            v-if="lsExtras.length"
                            class="assinaturas-lista"
                        >
                            <div
                                v-for="item in lsExtras"
                                :key="`extra-${item.idusuario}`"
                                class="assinatura-card extra"
                                :class="{ ativo: item.ckvincular === 'S' }"
                                @click="toggleAssinatura(item)"
                            >
                                <div class="assinatura-info">
                                    <div class="assinatura-nome">
                                        {{ item.nmusuario }}

                                        <span class="assinatura-badge-extra">
                                            OPCIONAL
                                        </span>
                                    </div>

                                    <div class="assinatura-perfil">
                                        {{ item.nmperfil }}
                                    </div>

                                    <div class="assinatura-fone">
                                        ☎ {{ item.celular || 'Telefone não informado' }}
                                    </div>
                                </div>

                                <div
                                    class="assinatura-toggle-area"
                                    @click.stop
                                >
                                    <span class="assinatura-status">
                                        {{
                                            item.ckvincular === 'S'
                                                ? 'Assinar'
                                                : 'Não assinar'
                                        }}
                                    </span>

                                    <label class="switch">
                                        <input
                                            v-model="item.ckvincular"
                                            type="checkbox"
                                            true-value="S"
                                            false-value="N"
                                        />

                                        <span class="slider"></span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div
                            v-else
                            class="info-empty"
                        >
                            Nenhum outro ADM ou RT disponível para este S.I.M.
                        </div>
                    </section>
                </template>
            </div>

            <div class="modal-footer">
                <div class="selecionados-info">
                    {{ totalSelecionados }}

                    {{
                        totalSelecionados === 1
                            ? 'assinatura selecionada'
                            : 'assinaturas selecionadas'
                    }}
                </div>

                <div class="modal-footer-actions">
                    <button
                        type="button"
                        class="btn-confirm"
                        :disabled="isLoading || isLoadingExtras"
                        @click="salvarDados"
                    >
                        Confirmar
                    </button>

                    <button
                        type="button"
                        class="btn-cancel"
                        :disabled="isLoading || isLoadingExtras"
                        @click="emit('close')"
                    >
                        Retornar
                    </button>
                </div>
            </div>

        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';

const emit = defineEmits([
    'close',
    'save'
]);

const props = defineProps({
    idEstabelecimento: {
        type: Number,
        default: 0
    },

    idSim: {
        type: Number,
        default: 0
    },

    idUsuario: {
        type: Number,
        default: 0
    },

    permitirOutros: {
        type: Boolean,
        default: false
    },

    tituloForm: {
        type: String,
        default: 'Vincular Assinaturas'
    },

    referencia: {
        type: Object,
        default: () => ({
            titulo: '',
            tabela: '',
            id: 0,
            protocolo: ''
        })
    }
});

const isLoading = ref(false);
const isLoadingExtras = ref(false);

const msgAlerta = ref(null);

const lsAssinaturas = ref([]);

const extrasCarregados = ref(false);
const exibirExtras = ref(false);

const lsSugeridas = computed(() => {
    return lsAssinaturas.value.filter(item =>
        normalizarSimNao(item.cksugerido) === 'S'
    );
});

const lsExtras = computed(() => {
    return lsAssinaturas.value.filter(item =>
        normalizarSimNao(item.cksugerido) === 'N'
    );
});

const totalSelecionados = computed(() => {
    return lsAssinaturas.value.filter(item =>
        item.ckvincular === 'S'
    ).length;
});

function normalizarSimNao(valor) {
    return String(valor || 'N')
        .trim()
        .toUpperCase();
}

function toggleAssinatura(item) {
    item.ckvincular = item.ckvincular === 'S'
        ? 'N'
        : 'S';
}

/**
 * Aplica os dados retornados pela API sem perder as seleções
 * feitas anteriormente pelo usuário.
 */
function aplicarLista(dados) {
    const selecoesAtuais = new Map(
        lsAssinaturas.value.map(item => [
            Number(item.idusuario),
            item.ckvincular
        ])
    );

    const usuarios = new Map();

    for (const item of dados || []) {
        const idUsuario = Number(item.idusuario);

        if (!idUsuario) {
            continue;
        }

        const selecaoAtual = selecoesAtuais.get(idUsuario);

        usuarios.set(idUsuario, {
            ...item,

            idusuario: idUsuario,

            cksugerido: normalizarSimNao(
                item.cksugerido
            ),

            ckvincular:
                selecaoAtual ??
                (
                    props.idUsuario === idUsuario
                        ? 'S'
                        : 'N'
                )
        });
    }

    lsAssinaturas.value = Array.from(
        usuarios.values()
    );
}

async function buscarAssinaturas(outros = 0) {
    const response = await Api.genericPost(
        '/dados/usuarios/lista/assinar',
        {
            idep: globalStore.idep,
            idsim: props.idSim,
            idestabelecimento: props.idEstabelecimento,
            intparam1: outros
        }
    );

    aplicarLista(response);
}

async function lerDados() {
    try {
        isLoading.value = true;
        msgAlerta.value = null;

        const carregarOutrosInicialmente =
            props.ckOutros ? 1 : 0;

        await buscarAssinaturas(
            carregarOutrosInicialmente
        );

        extrasCarregados.value =
            carregarOutrosInicialmente === 1;

        exibirExtras.value =
            carregarOutrosInicialmente === 1;

    } catch (error) {
        msgAlerta.value =
            'ATENÇÃO: Não foi possível acessar os dados do servidor: ' +
            `"${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}

async function alternarExtras() {
    if (extrasCarregados.value) {
        exibirExtras.value = !exibirExtras.value;
        return;
    }

    try {
        isLoadingExtras.value = true;
        msgAlerta.value = null;

        await buscarAssinaturas(1);

        extrasCarregados.value = true;
        exibirExtras.value = true;

    } catch (error) {
        msgAlerta.value =
            'ATENÇÃO: Não foi possível carregar os demais usuários: ' +
            `"${error.message}"`;
    } finally {
        isLoadingExtras.value = false;
    }
}

async function salvarDados() {
    try {
        isLoading.value = true;
        msgAlerta.value = null;

        const selecionados = lsAssinaturas.value.filter(item =>
            item.ckvincular === 'S'
        );

        if (!selecionados.length) {
            msgAlerta.value =
                'Selecione pelo menos uma assinatura antes de confirmar.';

            return;
        }

        for (const item of selecionados) {
            await Api.genericPut(
                '/cad/assinatura_pendencia',
                {
                    idep: globalStore.idep,

                    ref_titulo: props.referencia.titulo,
                    ref_tabela: props.referencia.tabela,
                    ref_id: props.referencia.id,
                    ref_protocolo: props.referencia.protocolo,

                    idusuarioass: item.idusuario,
                    nmusuarioass: item.nmusuario,

                    idlogin: globalStore.idlogin
                }
            );
        }

        emit('save');
        emit('close');

    } catch (error) {
        msgAlerta.value =
            'ATENÇÃO: Não foi possível salvar as assinaturas: ' +
            `"${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}

onMounted(lerDados);
</script>

<style scoped>
.modal-content.proc-modal-large {
    width: min(840px, calc(100vw - 32px));
    max-width: none;

    max-height: calc(100vh - 32px);

    padding: 0;

    display: flex;
    flex-direction: column;

    overflow: hidden;
    box-sizing: border-box;
}

.modal-header {
    flex: 0 0 auto;

    padding: 18px 20px 10px;

    border-bottom: 1px solid #e2e6e5;
    background: #fff;
}

.modal-header h2,
.modal-header h3 {
    margin: 0;
    text-align: center;
}

.modal-header h2 {
    font-size: 19px;
    line-height: 1.2;
}

.modal-header h3 {
    margin-top: 2px;

    font-size: 15px;
    line-height: 1.2;
}

.modal-alert {
    flex: 0 0 auto;
    margin: 10px 20px 0;
}

.modal-body {
    flex: 1 1 auto;
    min-height: 0;

    padding: 12px 20px;

    overflow-y: auto;
    overscroll-behavior: contain;
}

.modal-footer {
    flex: 0 0 auto;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    padding: 10px 20px;

    border-top: 1px solid #dde3e1;
    background: #fff;
}

.modal-footer-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.selecionados-info {
    font-size: 13px;
    font-weight: 600;
    color: #4f605d;
}

.loading-local {
    padding: 30px;

    text-align: center;
    color: #526360;
}

.assinatura-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    margin-bottom: 8px;
}

.assinatura-section-title {
    font-size: 14px;
    font-weight: 700;
    color: #263936;
}

.assinatura-section-subtitle {
    margin-top: 2px;

    font-size: 12px;
    color: #6c7977;
}

.assinatura-contador {
    flex: 0 0 auto;

    min-width: 28px;
    padding: 4px 8px;

    border-radius: 20px;

    background: #dff2e5;
    color: #237143;

    font-size: 12px;
    font-weight: 700;
    text-align: center;
}

.assinatura-contador.secundario {
    background: #edf1f3;
    color: #58666c;
}

.assinaturas-lista {
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.assinatura-card {
    display: flex;
    align-items: center;
    gap: 12px;

    padding: 9px 12px;

    border: 1px solid #ddd;
    border-radius: 8px;

    background: #f8f8f8;
    opacity: .68;

    cursor: pointer;

    transition:
        opacity .18s ease,
        border-color .18s ease,
        background-color .18s ease,
        box-shadow .18s ease;
}

.assinatura-card:hover {
    opacity: .92;

    border-color: #b9cbc8;
    background: #f4faf9;
}

.assinatura-card.ativo {
    opacity: 1;

    border-color: #3a9b5f;
    background: #f1faf4;

    box-shadow:
        0 0 0 1px rgba(58, 155, 95, .16);
}

.assinatura-card.extra:not(.ativo) {
    border-style: dashed;
    background: #fafbfb;
}

.assinatura-info {
    flex: 1;
    min-width: 0;

    text-align: left;
}

.assinatura-nome {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 7px;

    font-size: 15px;
    font-weight: 700;
    color: #13201f;

    line-height: 1.15;
}

.assinatura-badge-extra {
    display: inline-flex;
    align-items: center;

    padding: 2px 6px;

    border-radius: 10px;

    background: #eceff1;
    color: #667176;

    font-size: 9px;
    font-weight: 700;
    letter-spacing: .3px;
}

.assinatura-perfil {
    margin-top: 2px;

    font-size: 12px;
    color: #5f6b69;
    text-transform: uppercase;
}

.assinatura-fone {
    margin-top: 3px;

    font-size: 12px;
    color: #687573;
    font-style: italic;
}

.assinatura-toggle-area {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;

    flex: 0 0 auto;

    min-width: 130px;
    margin-left: auto;
}

.assinatura-status {
    font-size: 12px;
    font-weight: 600;
    color: #6c757d;

    white-space: nowrap;
}

.assinatura-card.ativo .assinatura-status {
    color: #2e8b4f;
}

.extras-action {
    display: flex;
    justify-content: center;

    margin: 14px 0;
}

button.btn-extras {
    width: auto;
    min-width: 260px;

    padding: 7px 16px;

    border: 1px solid #879795;
    border-radius: 6px;

    background: #f4f7f7;
    color: #334946;

    font-size: 13px;
    font-weight: 600;
}

button.btn-extras:hover:not(:disabled) {
    border-color: #526d69;
    background: #dfeae8;
    color: #18302c;
}

button.btn-extras:disabled {
    opacity: .6;
    cursor: wait;
}

.btn-extras-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    min-width: 20px;
    height: 20px;

    margin-left: 5px;

    border-radius: 50%;

    background: #667875;
    color: #fff;

    font-size: 11px;
}

.extras-section {
    padding-top: 4px;
}

.switch {
    position: relative;

    display: inline-block;

    width: 44px;
    height: 24px;

    flex: 0 0 auto;
}

.switch input {
    display: none;
}

.slider {
    position: absolute;
    inset: 0;

    cursor: pointer;

    background-color: #b8c0c5;
    border-radius: 20px;

    transition: .2s;
}

.slider::before {
    content: "";

    position: absolute;

    left: 3px;
    top: 3px;

    width: 18px;
    height: 18px;

    background-color: #fff;
    border-radius: 50%;

    transition: .2s;
}

.switch input:checked + .slider {
    background-color: #2f9854;
}

.switch input:checked + .slider::before {
    transform: translateX(20px);
}

.alert-error {
    padding: 10px;

    border-radius: 6px;

    background: #ffe6e6;
    color: #8a0000;
}

@media (max-width: 650px) {
    .modal-content.proc-modal-large {
        width: calc(100vw - 16px);
        max-height: calc(100vh - 16px);
    }

    .modal-header {
        padding: 14px 12px 8px;
    }

    .modal-body {
        padding: 10px 12px;
    }

    .modal-footer {
        padding: 10px 12px;

        flex-direction: column;
        align-items: stretch;
    }

    .modal-footer-actions {
        width: 100%;
    }

    .modal-footer-actions button {
        flex: 1;
        width: auto;
    }

    .selecionados-info {
        text-align: center;
    }

    .assinatura-card {
        align-items: flex-start;
        flex-direction: column;
    }

    .assinatura-toggle-area {
        width: 100%;
        min-width: 0;

        justify-content: flex-end;
    }

    button.btn-extras {
        width: 100%;
        min-width: 0;
    }
}
</style>